var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2528 2.29978C16.6525 1.90007 17.3005 1.90007 17.7002 2.29978C18.0999 2.69949 18.0999 3.34754 17.7002 3.74725L12.3838 9.06385C11.8664 9.58135 11.8664 10.4204 12.3838 10.9379L17.6984 16.2527C18.0981 16.6525 18.0981 17.3005 17.6985 17.7002C17.2988 18.0999 16.6507 18.0999 16.251 17.7002L10.9365 12.3854C10.419 11.8679 9.57994 11.8679 9.06243 12.3854L3.74882 17.6992C3.34912 18.0989 2.70109 18.0989 2.3014 17.6992C1.90171 17.2995 1.90171 16.6515 2.3014 16.2518L7.61512 10.9378C8.13259 10.4203 8.1326 9.58133 7.61512 9.06383L2.29977 3.74818C1.90008 3.34848 1.90008 2.70042 2.29976 2.30071C2.69945 1.901 3.34748 1.901 3.74717 2.30071L9.06244 7.61627C9.57995 8.13381 10.419 8.13381 10.9365 7.61628L16.2528 2.29978Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCross);
export default __webpack_public_path__ + "static/media/closeCross.810f4fc74ef31884aa04d0b64c0e0e62.svg";
export { ForwardRef as ReactComponent };